import { BCMSCurrency, DisabledPrompt, Link, useUIState } from "@bcm-dev/bcms-vite";
import { CustomAccordionClose, CustomAccordionContent } from "components/custom-ui/CustomAccordion";
import { FormContainer, FormRowView } from "components/shared";
import MobileTableAccordionView, { MobileTableAccordionDataItem, MobileTableAccordionToggle } from "components/shared/views/MobileTableAccordionView";
import React from "react";

import { SVGAsset } from "res";

/**
 * @function MobileTransferTemplatesTableAccordion
 * @param {STRING} templateType - Sets the transfer template type text.
 * @param {STRING} maxAmount - Sets the transfer maximum amount text.
 * @param {STRING} levelOfApproval - Sets the transfer level of approval text.
 * @param {STRING} note - Sets the transfer note text.
 * @return {React.Component}
 * @exported true
 * @description This is the mobile transfer template table accordion item.
 */
export default function MobileTransferTemplatesTableAccordion(props) {
  const template = props.template ?? {};
  const uiStateConfig = getTemplateAccordionConfig(props.template.id);
  const { config, key } = useUIState(uiStateConfig.key, uiStateConfig.value);
  const templateType = template.type ?? "[templateType]";
  const maxAmount = template.maxAmount ?? "[maxAmount]";
  const levelOfApprover = template.levelOfApprover ?? "[levelOfApproval]";
  const note = template.note ?? "[note]";

  return (
    <MobileTableAccordionView className="mobile-transfer-templates-table-accordion" state={ config.isActive }>
      
      <MobileTransferTemplatesItemHeader template={ template } />

      <CustomAccordionContent>
        <div className="custom-accordion-content-container">
          <div className="flex-container custom-accordion-header">
            <p className="flex-width custom-accordion-header-text">Template Details</p>

            <CustomAccordionClose className="set-width clickable">
              <SVGAsset id="CloseX" className="icon" />
            </CustomAccordionClose>
          </div>
          <FormContainer>
            <FormRowView text="Type">
              <p className="template-detail-text template-type">
                <span>{templateType}</span>
              </p>
            </FormRowView>
            <FormRowView text="Maximum Amount">
              <p className="template-detail-text maximum-amount">
                <span>{ maxAmount.format() }</span>
              </p>

            </FormRowView>
            <FormRowView text="Level of Approver">
              <p className="template-detail-text level-of-approver">
                <span>{levelOfApprover}</span>
              </p>

            </FormRowView>
            <FormRowView text="Note">
              <p className="template-detail-text note">
                <span>{note}</span>
              </p>
            </FormRowView>
            <FormRowView className="link-container">
              <DisabledPrompt>
                <Link>
                  <span className="link-text edit-template-link">Edit Template</span>
                </Link>
              </DisabledPrompt>
            </FormRowView>
            <FormRowView className="link-container">
              <DisabledPrompt>
                <Link>
                  <span className="link-text delete-template-link">Delete Template</span>
                </Link>
              </DisabledPrompt>
            </FormRowView>
          </FormContainer>
        </div>
      </CustomAccordionContent>
    </MobileTableAccordionView>
  );
}

export const getTemplateAccordionConfig = id => ({
  key: `Accordion_${ id }`,
  value: {
      isActive: false
  }
})

/**
 * @function MobileTransferTemplatesItemHeader
 * @param {STRING} templateName - Sets the transfer template name text.
 * @param {STRING} accountFrom - Sets the transfer account from text.
 * @param {STRING} accountTo - Sets the transfer account to text.
 * @param {STRING} defaultAmount - Sets the transfer default amount text.
 * @return {React.Component}
 * @exported true
 * @description The transfer templates item header in the table
 */
export function MobileTransferTemplatesItemHeader(props) {
  const template = props.template ?? {};
  const templateName = template.name ?? "[templateName]";
  const accountFrom = `${ template.fromAccount.nickname } - ${ template.fromAccount.number }`;
  const accountTo = `${ template.toAccount.nickname } - ${ template.toAccount.number }`;
  const defaultAmount = template.defaultAmount ?? BCMSCurrency().init(0);

  return (
    <MobileTableAccordionToggle icon={"RightChevronIcon"} rightValue="">
      <MobileTableAccordionDataItem columnHeader="Template Name:" data={templateName} />
      <MobileTableAccordionDataItem columnHeader="From:" data={ accountFrom } />
      <MobileTableAccordionDataItem columnHeader="To:" data={ accountTo } />
      <MobileTableAccordionDataItem columnHeader="Default Amount:" data={ defaultAmount ? defaultAmount.format() : "" } />
    </MobileTableAccordionToggle>
  );
}
